"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSearchEndpoint = void 0;
const endpoint_1 = require("../../general/endpoint");
class BaseSearchEndpoint extends endpoint_1.BaseGetEndpoint {
    constructor(request) {
        var _a;
        super();
        this.baseParams = {
            q: request.text,
            otherRegion: (_a = request.otherRegion) === null || _a === void 0 ? void 0 : _a.toString(),
            page: request.page,
            limit: request.limit,
            startFrom: request.startFrom,
        };
    }
}
exports.BaseSearchEndpoint = BaseSearchEndpoint;
